import React, {Component, Fragment} from "react";
import {Link} from "react-router-dom";
import SportIcon from "./SportIcon";
import {connect} from "react-redux";
import {filterData} from "../redux/actions/event-filter";
import _ from "lodash";

class FavoriteFilter extends Component {
	changeLeague(e) {
		this.props.filterData('league', {id : +e.target.value});
	}

	render() {
		const {favorites, filter} = this.props;
		const {leagues, sports} = this.props.live;
		const favoritesCount = favorites.length;
		const isFavorite = favoritesCount > 0;
		const favoriteLinkUrl = isFavorite ? `favourites/${favorites.join('-')}` : '';
		const sortedSports = _.sortBy(sports, i => i.name);
		const sportCount = sortedSports.length;

		const select = (
			<select className="animated slideInRight"
			        onChange={this.changeLeague.bind(this)} value={filter.league.id}>
				<option key="all_leagues" value={0}>Все чемпионаты</option>
				{leagues.filter((league) => {return +league.sport_id === filter.sport.sportId})
					.map((league) =>
						<option key={league.id} value={league.id}>{league.name}</option>)
				}
			</select>
		);

		const sportsOne = (
			<Fragment>
				<input type="radio"
				       id="all_sports"
				       name="filter"
				       onChange={() => {this.props.filterData('sport', {sportId : 0})}}
				/>
				<label htmlFor="all_sports">Все</label>

				{sortedSports.map((sport) =>
					<Fragment>
						<input type="radio"
						       id={`filter_${sport.id}`}
						       name="filter"
						       checked={+sport.id === filter.sport.sportId}
						       onChange={() => {this.props.filterData('sport', {sportId : +sport.id})}}
						/>
						<label htmlFor={`filter_${sport.id}`} title={sport.name}>
							<div className="sport-icon small">
								<SportIcon sportId={sport.id}/>
							</div>
						</label>

						{filter.sport.sportId !== 0 && +sport.id === filter.sport.sportId && select}
					</Fragment>)
				}
			</Fragment>
		);

		const sportsTwo = (
			<Fragment>
				<select onChange={(e) => {this.props.filterData('sport', {sportId : +e.target.value})}}
				        value={filter.sport.sportId}>
					<option value={0}>Все виды спорта</option>
					{sortedSports.map((sport) => <option value={sport.id}>{sport.name}</option>)}
				</select>

				{filter.sport.sportId !== 0 && select}
			</Fragment>
		);

		return (
			<div className="favorite-filter">
				<div>
					<Link to={favoriteLinkUrl} className="favorite-filter__favorites">
						<i className={`stars ${isFavorite > 0 ? 'activated' : ''}`}></i>&nbsp;Избранное&nbsp;
						<span className="favorite-filter__favorites__sup">{favorites.length}</span>
					</Link>

					<form className="favorite-filter__sports">
						{sportCount <= 10 ? sportsOne : sportsTwo}
					</form>
				</div>

				<div className="favorite-filter__services">
					<div className="services">
						<div className={`services__tv ${filter.tv ? 'active' : ''}`} onClick={() => {this.props.filterData('tv')}}></div>
						<div className={`services__zone ${filter.tracker ? 'active' : ''}`} onClick={() => {this.props.filterData('tracker')}}></div>
						<div className={`services__translation ${filter.video_online ? 'active' : ''}`} onClick={() => {this.props.filterData('video_online')}}></div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(
	state => ({
		live      : state.live,
		favorites : state.favorites,
		filter    : state.filter
	}),
	dispatch => ({
		filterData : (type, data = {}) => {
			dispatch(filterData(type, data))
		}
	})
)(FavoriteFilter);


// WEBPACK FOOTER //
// ./src/app/components/FavoriteFilter.js